export default __webpack_public_path__ + "static/media/033-bm.197bac28.webp";